module.exports = flarum.core.compat['common/Component'];